import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const UPDATE_USER_MUTATION = gql`
	mutation($sessionID: ID!, $data: JSON!) {
		updateSession(sessionID: $sessionID, data: $data) {
			id
			name
			owners {
				id
				username
				password
				firstName
				lastName
				roles
			}
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={UPDATE_USER_MUTATION} refetchQueries={['adminQuery']}>
		{updateSession => Propagator(children, updateSession)}
	</Mutation>
);
